module.exports = __webpack_public_path__ + "04_mustache_grey.56e77531.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/04_mustache_grey.png
// module id = uxp0
// module chunks = 0